import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { Tabs, Select } from "antd";
import Api from "../../utils/api";
import { useSelector, useDispatch } from "react-redux";
import { RankTable } from "./rankTable";
import { useNavigate } from "react-router-dom";

const { TabPane } = Tabs;
const { Option } = Select;

const Ranking = (props) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState(1);
  const [data, setData] = React.useState([]);
  const [value, setValue] = React.useState("");
  const userInfo = useSelector((s) => s.auth.userInfo);
  const match = userInfo?.matchList?.filter(
    (match) => match.status === "processing" || match.status === "finished"
  )[0];
  // if (!match) navigate("/home");
  const schoolName = userInfo?.schoolName;

  const onChange = async (value) => {
    setData([]);
    setValue(value);
    getDataRank("level", value);
  };

  const tabCb = (key) => {
    setActiveTab(parseInt(key));
  };

  const getDataRank = async (type, level) => {
    await Api.get(
      `ranking/getStudentRankingForTeacher?semister=${
        match.id
      }&week=${16}&scope=${type}&level=${level}`
    )
      .then((res) => {
        // console.log(res?.data?.result?.ranks?.all)
        const result = res?.data?.result?.ranks?.all;
        setData(result);
        if (result.length === 0) {
          alert("ไม่พบข้อมูล");
        }
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  useEffect(() => {
    setData([]);
    setValue([]);
    if (activeTab === 2) {
      getDataRank("school", "");
    }
  }, [activeTab]);

  const schoolLevels = [1, 2, 3, 4, 5, 6];

  return (
    <Container>
      <Background>
        <Title>ข้อมูล Ranking</Title>
        <CTab defaultActiveKey="1" onChange={tabCb} centered>
          <TabPane tab="ชั้นเรียน" key="1">
            <TitleClass>เลือกระดับชั้น</TitleClass>
            <SelectContainer>
              <SelectLevel
                placeholder="โปรดระบุ"
                optionFilterProp="children"
                size="large"
                style={{ width: "100%" }}
                onChange={onChange}
                value={value}
              >
                {schoolLevels.map((level) => (
                  <Option value={level}>ม.{level}</Option>
                ))}
              </SelectLevel>
            </SelectContainer>
            <RankContainer>
              {data.length ? (
                <RankTable data={data} title={"ชั้น ม." + value} />
              ) : null}
            </RankContainer>
          </TabPane>
          <TabPane tab="โรงเรียน" key="2">
            <RankContainer>
              {data.length ? (
                <RankTable data={data} title={schoolName} />
              ) : null}
            </RankContainer>
          </TabPane>
        </CTab>
      </Background>
    </Container>
  );
};

const CTab = styled(Tabs)`
  .ant-tabs-tab {
    width: 220px;
    justify-content: center;
    font-family: "Noto Sans Thai", "Noto Sans";
  }

  @media (max-width: 834px) {
    .ant-tabs-tab {
      width: 170px;
      justify-content: center;
      font-family: "Noto Sans Thai", "Noto Sans";
    }
  }

  .ant-select-selection-item {
    font-family: "Noto Sans Thai", "Noto Sans";
  }
`;

const SelectLevel = styled(Select)`
  font-family: "Noto Sans Thai", "Noto Sans";
`;

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1144px;
  min-height: 75vh;

  background-color: white;
  display: flex;
  flex-direction: column;

  ${responsive.tablet(css`
    max-width: 834px;
  `)}

  ${responsive.mobile(css`
    max-width: 375px;
  `)}
`;

const Title = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  letter-spacing: -0.02em;
  margin: 40px 180px;
  color: #4b5768;
  text-align: left;

  ${responsive.tablet(css`
    margin: 40px 180px;
  `)}

  ${responsive.mobile(css`
    margin: 40px 20px;
  `)}
`;

const TitleClass = styled.div`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 21px;

  margin: 24px 180px;

  color: #4b5768;
  ${responsive.tablet(css`
    margin: 24px 180px;
  `)}

  ${responsive.mobile(css`
    margin: 24px 20px;
  `)}
`;
const SelectContainer = styled.div`
  margin: 24px 180px;
  ${responsive.tablet(css`
    margin: 24px 180px;
  `)}

  ${responsive.mobile(css`
    margin: 24px 20px;
  `)}
`;

const RankContainer = styled.div`
  min-height: 250px;
  margin: 24px 180px;
  overflow: auto;
  max-height: calc(100vh - 425px);
  ${responsive.tablet(css`
    margin: 24px 180px;
  `)}

  ${responsive.mobile(css`
    margin: 24px 20px;
  `)}
`;

export default Ranking;
